export const Caio = {
  themeName: "Caio",
  isDark: false,
  CardViewBgColor: "#00ABBC10",
  secondaryLight: "#0B6E8080",
  primary: "#00ABBC",
  iconAppItem: "#00ABBC",
  AppText: "#000",
  loginFooter: "#000",
  connectBtn: "#00ABBC",
  loader: "#00ABBC",
  headerColor: "#00ABBC",
  primaryLight: "#00ABBC50",
  primaryColor: "#00ABBCB2",
  textColor: "#000",
  listBg: "#ffffff",
  containerLanguageIcon: "#ffffff",

  separatorColor: "#aaa",
  notFocusedLabelInput: "#000",

  danger: "#EE6E6E",
  warning: "#e59d4b",
  secondary: "#0B6E80",
  focusedLabelLoginInput: "#0B6E80",
  resetInputLogin: "#0B6E80",
  focusedBorderLoginInput: "#0B6E80",

  languageIcon: "#0B6E80",
  settingCollapseColor: "#eee",
  welcomeBg: "#F1FAFC",
  success: "#3ecd7e",
  primaryDark: "#0B6E80",
  offline: "#ec4545",
  offlineLabel: "#838383",
  labelColor: "#0B6E80",
  playerControl: "#FFFFFF30",
  whiteToast: "#FFF",
  loginText: "#FFF",
  blazeOrangeToast: "#FE6301",
  mantisToast: "#69C779",
  altoToast: "#D8D8D8",
  dustyGrayToast: "#979797",
  infoToast: "#00ABBC",
  yellowToast: "#edc300",
  greyToast: "#ccc",
  grayToast: "#aaa",
  lightToast: "#CDE6FC",
  appBg: "#f8f8f8",
  appBorder: "#e7e7e7",
  label: "#00ABBC",
  groupIcon: "#ffffff",
  borderRecord: "#00ABBC50",
  borderFormInput: "#eee",
  SelectedDrawerItem: "#CDE6FC",
  swipableBg: "#ffffff",
  landingScreenModeBg: "#F3F3F3",
  calenderBorder: "#CDE6FC",
  cancelButton: "#eee",
  listPlaceHolder: "#eee",
  fapMap: "#aaa",
  fapMapBg: "#ffffff",
  fapMapActive: "#00ABBC",
  listBgCard: "#eee",
  noItemToDisplay: "#ccc",
  listItem: "#ffff",
  linkColor: "#1D9BF0",
  bgLoginInput: "#EEEEEE1A",
  colorTextInput: "#000",
  loginBtnLabel: "#FFF",
  LogincolorTextInput: "#FFF",
  LogincolorLabelInput: "#00667F",
  loginOptions: "#fff",
  shadowBtnConnect: "#00ABBC",
  bnConnect: "#00ABBC",
  notfocusedBorderLoginInput: "#ffffff",
  headerPrimary: "#D3B97600",
  headerDark: "#AE8C4C00",
  headerText: "#00ABBC",
  notificationUpColor: "#F5FEFF",
  notificationDownColor: "#E5FDFF",

  listItemNotificationUpColor: "#F0FEFF",
  listItemNotificationDownColor: "#DBFCFF",

  listItemOfflineUpColor: "#FFFFFF",
  listItemOfflineDownColor: "#F1F3F4",

  notFocusedSocialMedia: "#00ABBC",
  loginBgFooter: "#fff",
  focusedSocialMedia: "#00ABBCcc",

  
  //Costum4
  loginFirstTabTitle:"#222",
  loginTabTitle:"#222",
  loginTabSelected:"#fff",
  loginTabNotSelected:"#ffffff4d",

  //CustomLanguge Modal
  languageContainerLeft:"#fff",
  languageContainerRight:"#00ABBC",
  submitLeftConnect:"#222",
  submitRightConnect:"#fff",
};
